import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useShippingWidgetConfiguration from './hooks/useShippingWidgetConfiguration/useShippingWidgetConfiguration'
import ShippingWidgetConfiguration from './ShippingWidgetConfiguration/ShippingWidgetConfiguration'
import ShippingWidgetConfigurationPageSkeleton from './ShippingWidgetConfigurationPageSkeleton/ShippingWidgetConfigurationPageSkeleton'
import * as Styles from './styles'

const ShippingWidgetConfigurationPage = () => {
  const { info } = useContext(AppContext)
  const { hasPermission } = useUserPermissions()
  const { setToastInfo } = useContext(ToastContext)

  const {
    shippingWidgetPreferences,
    applyingShippingWidgetPreferences,
    shippingWidgetBackgroundColor,
    setShippingWidgetBackgroundColor,
    shippingWidgetActionsColor,
    setShippingWidgetActionsColor,
    shippingWidgetTextColor,
    setShippingWidgetTextColor,
    shippingWidgetFreeShippingBackgroundColor,
    setShippingWidgetFreeShippingBackgroundColor,
    shippingWidgetFreeShippingTextColor,
    setShippingWidgetFreeShippingTextColor,
    shippingWidgetSortingType,
    setShippingWidgetSortingType,
    gettingShippingWidgetPreferences,
    shippingWidgetHasChanges,
    revertShippingWidgetChanges,
    shippingWidgetScriptInfo,
    onSave,
  } = useShippingWidgetConfiguration({
    storeId: info.selectedStore.id,
    setToastInfo,
  })

  if (gettingShippingWidgetPreferences) {
    return <ShippingWidgetConfigurationPageSkeleton />
  }

  return (
    <Styles.Container>
      {shippingWidgetHasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editExtra)} />}
      <ShippingWidgetConfiguration
        backgroundColor={shippingWidgetBackgroundColor}
        textColor={shippingWidgetTextColor}
        actionsColor={shippingWidgetActionsColor}
        onChangeBackgroundColor={setShippingWidgetBackgroundColor}
        onChangeTextColor={setShippingWidgetTextColor}
        onChangeActionsColor={setShippingWidgetActionsColor}
        freeShippingBannerBackgroundColor={shippingWidgetFreeShippingBackgroundColor}
        onChangeFreeShippingBackgroundColor={setShippingWidgetFreeShippingBackgroundColor}
        freeShippingBannerTextColor={shippingWidgetFreeShippingTextColor}
        onChangeFreeShippingTextColor={setShippingWidgetFreeShippingTextColor}
        widgetPreferences={shippingWidgetPreferences}
        sortingType={shippingWidgetSortingType}
        onChangeSortingType={setShippingWidgetSortingType}
        scriptInfo={shippingWidgetScriptInfo}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editExtra) && shippingWidgetHasChanges}
        onSave={onSave}
        onRevertChanges={revertShippingWidgetChanges}
        loading={applyingShippingWidgetPreferences || gettingShippingWidgetPreferences}
        disabled={applyingShippingWidgetPreferences || gettingShippingWidgetPreferences}
      />
    </Styles.Container>
  )
}

export default ShippingWidgetConfigurationPage
